import { useEffect, useMemo } from "react"

export function useIntersectionObserver(callback: IntersectionObserverCallback, options?: IntersectionObserverInit): IntersectionObserver {
  const intersectionObserver = useMemo(() => new IntersectionObserver(callback, options), [callback, options])
  useEffect(() => () => intersectionObserver.disconnect(), [intersectionObserver])
  return intersectionObserver
}